//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { VueAutosuggest } from 'vue-autosuggest'

export default {
  components: {
    VueAutosuggest
  },
  props: {
    variant: {
      type: String,
      default: 'dark'
    },
    value: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    inputClass: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      suggestions: [{ data: [] }],
    }
  },
  fetchKey: 'form-company-input',
  computed: {
    classForInput () {
      const cls = [
        'tw-form-input tw-appearance-none tw-min-w-0 tw-w-full tw-border tw-border-transparent tw-rounded-md tw-py-2.5 tw-text-sm focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2'
      ]

      if (this.variant === 'light') {
        cls.push('tw-bg-white tw-text-gray-800 tw-placeholder-gray-500 focus:tw-ring-offset-gray-900 focus:tw-ring-white focus:tw-border-white focus:tw-placeholder-gray-400')
      } else {
        cls.push('tw-bg-gray-100 tw-text-gray-800 tw-placeholder-gray-600 focus:tw-ring-offset-white focus:tw-ring-gray-200 focus:tw-border-gray-100 focus:tw-placeholder-gray-400')
      }

      if (this.value) {
        cls.push('tw-pt-4 tw-pb-1')
      } else {
        cls.push('tw-py-2')
      }

      if (this.inputClass) {
        cls.push(this.inputClass)
      }

      return cls
    }
  },
  watch: {
    async value (value) {
      if (!value || !this.$country.is(this.$country.FINLAND)) {
        this.suggestions[0].data = []
        return
      }

      try {
        const response = await this.$axios.post(
          `${this.$config.meiliApiUrl}/indexes/${this.$config.meiliIntelligenceIndexName}/search`,
          {
            q: value,
            limit: 5
          },
          {
            headers: {
              Authorization: `Bearer ${this.$config.meiliIntelligenceSearchKey}`
            }
          }
        )
        this.suggestions[0].data = response.data.hits
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
        this.suggestions[0].data = []
      }
    }
  },
  methods: {
    onInput (value) {
      this.$emit('input', value)
    },
    onSelected (value) {
      this.$emit('company', {
        name: value.item.title,
        ident: value.item.ident
      })
    },
    getSuggestionValue (value) {
      return value.item.title
    }
  }
}
